/**
  @function dataFold
  @desc Given a JSON object where the data values and headers have been split into separate key lookups, this function will combine the data values with the headers and returns one large array of objects.
  @param {Object} json A JSON data Object with `data` and `headers` keys.
  @param {String} [data = "data"] The key used for the flat data array inside of the JSON object.
  @param {String} [headers = "headers"] The key used for the flat headers array inside of the JSON object.
*/
export default (function (json) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "data";
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "headers";
  return json[data].map(function (data) {
    return json[headers].reduce(function (obj, header, i) {
      return obj[header] = data[i], obj;
    }, {});
  });
});